import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayIncludes',
  standalone: true
})
export class ArrayIncludesPipe implements PipeTransform {

  transform(searchElement: any, array: any[]): boolean {
    if (!array?.length || !searchElement) {
      return false;
    }

    return array.includes(searchElement);
  }

}
